import "./ImportantNotices.css";
import { Col, Row } from "react-bootstrap";
import parse from "html-react-parser";
import { Link } from "react-router-dom";
import axios from "axios";
import { useEffect, useState } from "react";
import moment from "moment";

const getYearList = (step) => {
  const currentYear = new Date().getFullYear();
  return Array.from(
    { length: (currentYear - 1 - currentYear) / step + 2 },
    (_, i) => currentYear + i * step
  );
};

const ImportantNotices = () => {
  const [importantNoticeList, setImportantNoticeList] = useState([]);
  const [importantNoticeListCms, setImportantNoticeListCms] = useState([]);

  useEffect(() => {
      const fetchImportantNotice = async () => {
        try {
          const response = await axios.get(
            "https://www.alrajhibank.com.my/assets/contents/important-notice.json"
          );
          const jsonResponse = response.data;
          setImportantNoticeList(jsonResponse);
        } catch (error) {
          console.error("Error fetching data", error);
        }
      };

      const fetchImportantNoticeFromCMS = async () => {
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_CMS_BASE_URL}/important-notices?populate=*`,
            {
              headers: {
                Authorization: `Bearer ${process.env.REACT_APP_CMS_TOKEN}`,
              },
            }
          );
  
          const formatToLegacy = response.data.data.map(notice => {
            return {
              title: notice.header,
              date: moment(notice.date).format("DD MMM YYYY"),
              slug: notice.slug,
              content: notice.contentTemplate,
              type: notice.type,
              tag: notice.yearTag,
            }
          });

          setImportantNoticeListCms(formatToLegacy);
        } catch (error) {
          console.error("Error fetching data", error);
        }
      };

      fetchImportantNotice();
      fetchImportantNoticeFromCMS();
  }, []);

  const [year, setYear] = useState(new Date().getFullYear().toString());

  return (
    <div className="important-notices container my-5">
      <div className="heading">Important Notices</div>
      <div className="year-selector">
        {getYearList(-1).map((y) => (
          <button
            className={`year-btn ${year === y.toString() ? `active` : ``}`}
            onClick={() => setYear(y.toString())}
          >
            {y.toString()}
          </button>
        ))}
      </div>
      <Row className="notice-list">
        {[...importantNoticeListCms, ...importantNoticeList]
          .sort((a, b) => moment(b.date).valueOf() - moment(a.date).valueOf())
          .filter((notice) => notice.tag === year)
          .map((notice) => {
            return (
              <Col md={4}>
                <div className="notice-card">
                  <div className="title">{notice.title}</div>
                  <div className="subtitle">{parse(notice.content)}</div>
                  <div className="cta-date">
                    <Link to={`/important-notice-detail/${notice.slug}`}>
                      Read more
                    </Link>
                    <div className="date">{notice.date}</div>
                  </div>
                </div>
              </Col>
            );
          })}
      </Row>
    </div>
  );
};

export default ImportantNotices;
